import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/styles/createStyles';
import { palette } from '@shared/consts';

export const useStyles = makeStyles((theme) =>
  createStyles({
    actions: {
      padding: theme.spacing(2, 0, 1),
    },
    button: {
      backgroundColor: palette.white,
      zIndex: 1,
      height: 46,
    },
    closeIcon: {
      marginLeft: theme.spacing(2),
    },
    content: {
      minHeight: 200,
      padding: theme.spacing(2, 0, 0),
    },
    titleIcon: {
      color: palette.internationalOrange,
      marginRight: theme.spacing(1),
    },
  }),
);
